import moment from 'moment-timezone';

import { EventsFilter } from '../interfaces';
import { initialEventFiltersState } from '../reducers/eventFilters/eventFiltersState';
import { VideoStatus } from '../enums';

const fleetToFilterMap = new Map<number, Partial<EventsFilter>>([
  [
    1, // MTA
    {
      dateFrom: moment().subtract(7, 'day').startOf('day').toISOString(),
      dateTo: moment().toISOString(),
      selectedFilters: ['BUS_LANE_MATCH'],
      human_review: true,
      media_statuses: [VideoStatus.publishedStr],
      whitelist: false,
    } as Partial<EventsFilter>,
  ],
  [
    40, // MTA Replay
    {
      dateFrom: moment().subtract(7, 'day').startOf('day').toISOString(),
      dateTo: moment().toISOString(),
      selectedFilters: ['BUS_LANE_MATCH'],
      human_review: true,
      media_statuses: [VideoStatus.publishedStr],
      whitelist: false,
    } as Partial<EventsFilter>,
  ],
  [
    2256, // SacRT Bus Stop Shelter
    {
      dateFrom: moment().subtract(7, 'day').startOf('day').toISOString(),
      dateTo: moment().toISOString(),
      include_tags: true,
      tags: {
        'td:665': 'ev:2015', // Graffiti SacRT bus stop shelter tags
      },
    },
  ],
]);

export const fleetDefaultFilters = (fleetId: number): Partial<EventsFilter> => {
  if (fleetToFilterMap.has(fleetId)) {
    return { ...initialEventFiltersState.filter, ...fleetToFilterMap.get(fleetId) };
  }
  return { ...initialEventFiltersState.filter };
};

export const fleetCleanFilters = (): Partial<EventsFilter> => {
  return { ...initialEventFiltersState.filter };
};
